import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export class SuccessIcalModal extends React.Component {
  render () {
    const { toggleModal, showModal } = this.props;
    return (
      <BootstrapModal
        showModal={showModal}
        header={
          <h3>
            <FormattedMessage
              id="hosting.calendar_main.import_success_modal_heading"
              defaultMessage="Import successful"
            />
          </h3>
        }
        body={
          <div className="margin-xxl-bottom">
            <p className="margin-xxl-bottom">
              {/* TEMPORARY FIX - removing export button, text was swapped out for a version that does not mention sharing calendar */}
              {/* <FormattedMessage
                id="hosting.calendar_main.import_success_modal_description"
                defaultMessage="Your calendar is connected. Now share your Peerspace calendar with your external calendar."
              /> */}
              <FormattedMessage
                id="hosting.modal_sync_cal_success.header"
                defaultMessage="Your calendar has {break} successfully been connected"
                values={{
                  break: <br />
                }}
              />
            </p>
            {/* <button
              onClick={this.props.getExportId}
              className="btn btn-primary btn-block classic"
            >
              <FormattedMessage
                id="hosting.calendar_main.import_success_cta"
                defaultMessage="Share calendar"
              />
            </button> */}
          </div>
        }
        bodyClass="sync-modal-body text-center"
        toggleModal={toggleModal}
      />
    );
  }
}

SuccessIcalModal.propTypes = {
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func
};
